import React from 'react';
import MyNavbar from '../../../components/general/mynavbar/MyNavbar';
import Footer from '../../../components/general/footer/Footer'

import ShopPage from '../../../subscreens/customer/shop/shoppage/ShopPage';

import Salebanner from '../../../subscreens/customer/home/Salebanner/SaleBanner';
import useScrollToTop from "../../../contexts/UseScrolltoTop";
const Shops=()=>{
    useScrollToTop();
    return(
        <>
        <MyNavbar />  
         {/* <ShopBanner />   */}
        <ShopPage /> 
        {/* <Salebanner /> */}
        <Salebanner />
        <Footer /> 
       
     
     </>
    );

}
export default Shops;
